export default "__VITE_ASSET__wTpY2tur__"